BrowseContentView = require './views/content'
BrowseHeaderTitleHelper = require './helpers/header_title'
BrowseUpdateAppUrlHelper = require './helpers/update_app_url'
BrowseUrlContructionHelper = require './helpers/url_construction'
BrowseParsedParamsHelper = require './helpers/parsed_params'
DealsMmSearch = require '../../deals/frontend/mm_search'
DealsPaginationEvents = require '../../deals/frontend/pagination_events'
PaginatedDealsBuilder = require '../../deals/frontend/helpers/paginated_deals_builder'
RefinementUI = require 'grpn-refinement-ui/lib/frontend/application'
SortToggleApplication = require '../../grpn-sorts/frontend/application'
SpinnerGroup = require './helpers/spinner_group'
ToolTipDelayView = require './views/tool_tip_delay'

BROWSE_REFINEMENT_KEYS = [
  'category'
  'category2'
  'interest'
  'minPrice'
  'maxPrice'
  'price'
  'query'
]

module.exports = class BrowseApplication
  refinementUIAppInstance = browseContentViewInstance = undefined

  constructor: ({
    @isLeftBarVisible, @isOnNoDealsPage, @goodsBrowsePageLayoutValue,
    @inNewHomepage, @carouselConfig, @homeWidgetPreview, @showFreeShippingModal,
    @selectedCategory, @isSeoEnabled, @isVanityUrl, @collection,
    @inGoodsHomepageSSR, @showClearanceWidget, @inRAPI, @useNewGAPIConnector
  }) ->
    @assignUrlBuilder()

  assignUrlBuilder: ->
    @constructUrl = switch
      when @collection then BrowseUrlContructionHelper.getConstructCollectionById(@collection.id , @collection.type)
      when @isSeoEnabled then BrowseUrlContructionHelper.constructV3
      else BrowseUrlContructionHelper.constructV1

  isMmHome: ->
    queryKeys = _.keys Groupon.Utils.unparam()

    @goodsBrowsePageLayoutValue is 'mmhome' and
    not _.intersection(queryKeys, BROWSE_REFINEMENT_KEYS).length and
    not @collection and not @isVanityUrl

  startApp: ->
    if @isMmHome()
      @renderMmHomeDeals(
        new DealsMmSearch({
          @inNewHomepage, @carouselConfig, @homeWidgetPreview, @showFreeShippingModal, @inGoodsHomepageSSR
        })
      )
    else
      if @isLeftBarVisible
        initRefinementUI @constructUrl
      else
        initAppWithoutRefinementUI()

      relocateInAppMessages()
      initSortsApp()

  resetRefinementUi: =>
    if refinementUIAppInstance?
      refinementUIAppInstance.updateRefinements Groupon.refinementUiPageData, queue: true
      BrowseUpdateAppUrlHelper.updateFromRefinements refinementUIAppInstance.selectedRefinements, @constructUrl

  renderContent: (options) =>
    browseContentViewInstance?.render options

  initAppWithoutRefinementUI = ->
    browseContentViewInstance = new BrowseContentView isContentRendered: true

  initRefinementUI = (constructionLibrary) ->
    {updateFromRefinements, getEnabledFacets, getParsedParams} = BrowseUpdateAppUrlHelper

    facetFilterKeys = Groupon.facetFilterKeys ? []
    categoryAttributesEnabled = Groupon.categoryAttributesEnabled ? {}
    refinementUiOptions = Groupon.refinementUiOptions ? {}
    refinementUiOptions.container = '#refinement-ui'
    refinementUIAppInstance = new RefinementUI Groupon.refinementUiPageData, refinementUiOptions

    BrowseHeaderTitleHelper.updateHeaderTitle $('.page-header .title'),
      Groupon.refinementUiPageData, Groupon.seoMetaHash

    refinementUIAppInstance.events.on 'refinementsUpdated', (selectedRefinements, selectedId) ->
      Groupon.browseApp.lastUpdatedRefinementId = selectedId

      _filterSelectedRefinements = (Lm, categoryName) ->
        return unless LmWhitelist = categoryAttributesEnabled[Lm]
        whitelist = LmWhitelist[categoryName] ? []
        for facetName in facetFilterKeys
          if facetName not in whitelist
            delete selectedRefinements[facetName]

      if not (l1 = selectedRefinements.category) # no category, no ops

      else if not (l2 = l1.selectedValues?[0]) # when on '/goods/all'
        _filterSelectedRefinements 'L2', 'all'

      else if not (l3 = l2.selectedValues?[0]) # when on L2
        _filterSelectedRefinements 'L2', l2.name

      else if not (l4 = l3.selectedValues?[0]) # when on L3
        _filterSelectedRefinements 'L3', l3.name

      updateFromRefinements selectedRefinements, constructionLibrary
      updatePageContent()

    browseContentViewInstance = new BrowseContentView {
      isContentRendered: true
      refinementUIAppInstance
    }

    if refinementUIAppInstance.selectedRefinements
      enabledFacets = getEnabledFacets refinementUIAppInstance.selectedRefinements
      BrowseParsedParamsHelper.setParsedParams getParsedParams enabledFacets

  updatePageContent = ->
    fetchAndRenderDeals()
    OptimizeSuite.treatAsNewPage window.location.href

  initNewRatingSortMessage = ->
    return if (Cookie.get('goodsNewRatingSortMessage') is 'hide') \
      or not Groupon.showSortByRatings \
      or not (ratingTooltipElem = $('.rating-sort-tooltip-container')).length

    ratingTooltipElem.fadeIn 200

    $('.rating-sort-tooltip-container .rating-sort-tooltip-close').one 'click', ->
      ratingTooltipElem.fadeOut 200
      Cookie.set 'goodsNewRatingSortMessage', 'hide'

  initSortsApp = (constructionLibrary) ->
    $ ->
      sortsApp = SortToggleApplication
      sortsApp.initialize()

      sortsApp.on 'change:sort', (selectedRefinements) ->
        BrowseUpdateAppUrlHelper.updateFromSorts selectedRefinements
        fetchAndRenderDeals()

      browseContentViewInstance?.setSortsApp sortsApp

      initNewRatingSortMessage()

  relocateInAppMessages = ->
    $ ->
      banner = $('#in-app-messages').detach()
      banner.find('.hide-link').click ->
        banner.slideUp()
      banner.appendTo('#inAppMessageBanner')

  fetchAndRenderDeals = ->
    paginatedBuilder = new PaginatedDealsBuilder

    browseContentViewInstance ?= new BrowseContentView()

    browseContentViewInstance.setDealsSearch paginatedBuilder.search
    browseContentViewInstance.render
      paginatedDealsBuilder: paginatedBuilder

    paginatedBuilder.on 'fetchSuccess', (search) ->
      if Groupon.refinementUiPageData
        {refinementUiPageData, seoMetaHash} = search.page
        Groupon.refinementUiPageData = refinementUiPageData
        Groupon.seoMetaHash = seoMetaHash if seoMetaHash

        refinementUIAppInstance.updateRefinements refinementUiPageData
        BrowseHeaderTitleHelper.updateHeaderTitle $('.page-header .title'),
          refinementUiPageData, seoMetaHash

      DealsPaginationEvents.trigger 'newPage', search.page

  renderMmHomeDeals: (mmSearch) ->
    @_startSpinner()

    mmSearch.on 'error', =>
      @_onDoneFetchingDeals =>

    mmSearch.on 'success', (deals, dealIdList) =>
      @_onDoneFetchingDeals =>
        $ =>
          $('#browse_deals_container').replaceWith deals
          GIG.Tooltip.reloadBindings document.body

  _onDoneFetchingDeals: (renderContentCallback) ->
    renderContentCallback()
    @_stopSpinner()

  _stopSpinner: ->
    SpinnerGroup.stop 'deal-space', remove: true

  _startSpinner: ->
    SpinnerGroup.start 'deal-space',
      parentElem: $('#deal-space')
      css: marginTop: '100px'
      useV2: true
